// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserMenu_wrapper__3KSXQ","username":"UserMenu_username__2nvIz"};